module.exports = __webpack_public_path__ + "static/img/40003 (2).f34e407.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40003 (2).webp
// module id = dJhi
// module chunks = 14